import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Checkbox } from '@toqio/toqio-web-components';
import { Field } from '../../../shared/Field';
import type { HelloWorldValues } from '../schema';

/**
 * Step 2 — email and newsletter preference.
 *
 * Demonstrates two patterns:
 *  - Text input via the `Field` wrapper (design-system TextField + RHF).
 *  - Boolean toggle via the design-system `Checkbox` component wired with
 *    `useController` from react-hook-form.
 */
export const Step2: React.FC = () => {
  const { control } = useFormContext<HelloWorldValues>();
  const { field: newsletterField } = useController<HelloWorldValues>({
    name: 'newsletter',
    control,
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20, maxWidth: 480 }}>
      <Field<HelloWorldValues>
        name="email"
        label="Email"
        placeholder="you@example.com"
        type="email"
      />
      <Checkbox
        checked={Boolean(newsletterField.value)}
        onChange={(checked: boolean) => newsletterField.onChange(checked)}
        label="Subscribe me to occasional product updates"
      />
    </div>
  );
};
